'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _curry = require('./curry');

var _curry2 = _interopRequireDefault(_curry);

var _getIn2 = require('./internal/_getIn');

var _getIn3 = _interopRequireDefault(_getIn2);

var _setIn2 = require('./internal/_setIn');

var _setIn3 = _interopRequireDefault(_setIn2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function updateIn(keyPath, updater, subject) {
  var value = (0, _getIn3.default)(keyPath, subject);
  return (0, _setIn3.default)(keyPath, updater(value), subject);
}

/**
 * Apply `updater` to the value at `keyPath`.
 *
 * @example
 * const incrementUserCount = updateIn(['users', 'count'], n => n + 1);
 * incrementUserCount({users: {count: 1}});
 * // returns {users: {count: 2}}
 *
 * @example <caption>Unset keyPaths will be set based on the most recent type.</caption>
 * const incrementUserCount = updateIn(['users', 'count'], (n = 0) => n + 1);
 * incrementUserCount({});
 * // returns {users: {count: 1}}
 *
 * incrementUserCount(Map());
 * // returns Map { users => Map { count => 1 } }
 *
 * @param  {Array<any>|Iterable<any>} keyPath the location where `updater` should be applied.
 * @param  {Function} updater the tranformation to apply.
 * @param  {Array|Iterable|Object} subject the thing to update.
 * @return {Array|Iterable|Object}
 */
exports.default = (0, _curry2.default)(updateIn);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/transmute/static-2.3/updateIn.js
// module id = 394
// module chunks = 0 1